module.exports = __webpack_public_path__ + "img/img_result-stand-04.a089cffb.png";